import { ObjectMapper } from "json-object-mapper";
import { WorkforceplanMovementType } from "services/enums/WorkforceplanMovementType.enum";
import { WorkforcePlanRequestType } from "services/enums/WorkforcePlanRequestType.enum";
import { WorkforceplanSolicitationStatus } from "services/enums/WorkforceplanSolicitationStatus.enum";
import { IModel } from "services/models/IModel";
import { Model } from "services/models/model";

export class WorkforcePlanSolicitationStepModel
	extends Model
	implements IModel<WorkforcePlanSolicitationStepModel> {
	id: string = "";
	approvalScopeItemId: string = "";
	sequence: number = 0;
	approverId: string = "";
	approverName: string = "";
	approverImage: string = "assets/images/logo/avatar-profile.png";
	approverJobTitleName: string = "";
	status: string = "";
	stepName: string = "";
	note: string = "";
	approvalLevelName: string = "";
	approvalProfileName: string = "";
	effectiveDate: string = "";

	get statusData(): WorkforceplanSolicitationStatus {
		return WorkforceplanSolicitationStatus.getBy(this.status);
	}

	static create(input: any): WorkforcePlanSolicitationStepModel {
		return ObjectMapper.deserialize<WorkforcePlanSolicitationStepModel>(
			WorkforcePlanSolicitationStepModel,
			input
		);
	}

	public toJSON(): string {
		return ObjectMapper.serialize(this) as string;
	}
}

export class WorkforcePlanSolicitationModel
	extends Model
	implements IModel<WorkforcePlanSolicitationModel> {
	movementType: any = WorkforceplanMovementType.WORK_FORCEPLAN.id;
	movementSubType: string = "";
	workforcePlanId: string = "";
	approvalScopeItemId: string = "";
	effectiveDate: string = "";
	note: string = "";
	status: string = "";
	payload: string = "";
	requesterId: string = "";
	requesterName: string = "";
	requesterImage: string = "assets/images/logo/avatar-profile.png";
	employeeId: string = "";
	employeeName: string = "";
	employeeImage: string = "assets/images/logo/avatar-profile.png";
	workScaleGroup: string = "";
	totalSteps: number = 0;
	totalDone: number = 0;
	convertedFromMovementRequestId: string = "";
	convertedToMovementRequestId: string = "";
	currentStepName: string = "";
	currentStepDays: number | null = null;
	steps: WorkforcePlanSolicitationStepModel[] = [];

	get statusBadge(): string {
		const status = WorkforceplanSolicitationStatus.getBy(this.status);

		return `<span class="badge bg-${status?.className}">${status?.label}</span>`;
	}

	get statusData(): WorkforceplanSolicitationStatus {
		return WorkforceplanSolicitationStatus.getBy(this.status);
	}

	get movementTypeData(): WorkforceplanMovementType {
		return WorkforceplanMovementType.getByAny(this.movementType) as WorkforceplanMovementType;
	}

	get movementTypeLabel() {
		const movementTypeLabel = this.movementTypeData?.label ?? "Solicitação";
		return this.movementSubType ? movementTypeLabel + `/${this.movementSubType}` : movementTypeLabel;
	}

	get movementTypeEnumerator() {
		switch (this.movementType) {
			case WorkforceplanMovementType.DISMISSAL.value:
				return WorkforcePlanRequestType.REQUEST_DISMISSAL;
			case WorkforceplanMovementType.TRAINNING.value:
				return WorkforcePlanRequestType.REQUEST_TRAINING;
			case WorkforceplanMovementType.APTITUDE_TRAINNING.value:
				return WorkforcePlanRequestType.REQUEST_APTITUDE_TRAINING;
			case WorkforceplanMovementType.SHIFT_CHANGE.value:
				return WorkforcePlanRequestType.SHIFT_CHANGE;
			case WorkforceplanMovementType.NEW_HIRING_SUBSTITUTION.value:
				return WorkforcePlanRequestType.REQUEST_HIRING_SUBSTITUTION;
			case WorkforceplanMovementType.NEW_HIRING_REPLACEMENT.value:
				return WorkforcePlanRequestType.REQUEST_HIRING_REPLACEMENT;
			case WorkforceplanMovementType.COST_CENTER_AND_JOB_TITLE_CHANGE.value:
				return WorkforcePlanRequestType.COST_CENTER_AND_JOB_TITLE_CHANGE;
			// case WorkforceplanMovementType.JOB_TITLE_CHANGE.value:
			// 	return WorkforcePlanRequestType.JOBTITLE_CHANGE;
			case WorkforceplanMovementType.NEW_HIRING_INCREASE.value:
				return WorkforcePlanRequestType.REQUEST_HIRING_INCREASE;
			case WorkforceplanMovementType.WORK_FORCEPLAN.value:
				return WorkforcePlanRequestType.REQUEST_WORK_FORCEPLAN;
			case WorkforceplanMovementType.PROMOTION.value:
				return WorkforcePlanRequestType.REQUEST_PROMOTION;
			case WorkforceplanMovementType.DISCIPLINARY_MEASURE.value:
				return WorkforcePlanRequestType.REQUEST_DISCIPLINARY_MEASURE;
			case WorkforceplanMovementType.NEW_REQUEST_FEEDBACKS.value:
				return WorkforcePlanRequestType.REQUEST_FEEDBACK;
			case WorkforceplanMovementType.PROMOTION.value:
				return WorkforcePlanRequestType.REQUEST_PROMOTION;
		}
	}

	static create(input: any): WorkforcePlanSolicitationModel {
		return ObjectMapper.deserialize<WorkforcePlanSolicitationModel>(
			WorkforcePlanSolicitationModel,
			input
		);
	}

	public toJSON(): string {
		return ObjectMapper.serialize(this) as string;
	}
}
